import { isString } from "../types/isString";

const pattern = new RegExp(
  "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // or IP (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    "(\\#[-a-z\\d_]*)?$",
  "i",
);

/**
 * Checks if the given value is a valid URL.
 *
 * The function uses a regular expression to validate the URL format. It supports
 * protocols (http, https), domain names, IP addresses (v4), ports, paths, query strings,
 * and fragments.
 *
 * @param value - The value to be checked.
 * @returns `true` if the value is a valid URL, `false` otherwise.
 */
export const isValidURL = (value: unknown): boolean => {
  if (!isString(value)) {
    return false;
  }
  return pattern.test(value);
};
